<template>
  <div class="ms-1 me-2">
    <el-badge :value="unreaded" :max="9">
      <el-popover placement="bottom-end" trigger="click">
        <div class="el-popover__notifications">
          <dara-notification-list :pagination="pagination" />
          <div class="align--center mt--lg">
            <dara-button :plain="true" @click="goToListNotifications()">{{ $t('notification-panel') }}</dara-button>
          </div>
        </div>
        <dara-icon slot="reference" class="flex-fill cursor--pointer" icon="bell" />
      </el-popover>
    </el-badge>
  </div>
</template>

<script>
import { goToListNotifications, fetchNotifications } from '@/modules/notification/notification.service';

import DaraNotificationList from '@/modules/notification/components/NotificationList.vue';

export default {
  name: 'DaraTopbarNotificationPanel',
  components: {
    DaraNotificationList,
  },
  data() {
    return {
      pagination: {
        page: 1,
        limit: 5,
      },
      unreaded: null,
    };
  },
  mounted() {
    this.fetchNotifications();
  },
  methods: {
    goToListNotifications,
    fetchNotifications() {
      fetchNotifications(this.pagination)
        .then(data => {
          Object.assign(this.pagination, data.pagination);
          if (data.unreaded > 0) {
            this.unreaded = data.unreaded;
          }
        })
        .catch(() => {
          this.notifications = null;
        });
    },
  },
};
</script>
